import React, { Component, ReactNode } from 'react';
import NavigationBlock from '../../features/navigation/NavigationBlock';
import { RouteComponentProps } from 'react-router-dom';
import Alert from 'react-bootstrap/Alert';
import './MeasurementUnanswered.scss';
import { ERouterPath } from '../../features/router/ERouterPath';
import { ApplicationState } from '../../app/store';
import { connect } from 'react-redux';
import { MeasurementTypeEnum } from '../../api/types';
import { Api } from '../../api';
import { Measurement } from '../../models/Measurement';
import Spinner from 'react-bootstrap/Spinner';
import { IDossierV2 } from '../../models/DossierV2';
import { MeasurementSplitLayout } from './MeasurementSplitLayout';

interface MeasurementUnansweredProps extends RouteComponentProps {
  dossier?: IDossierV2;
}

interface MeasurementUnansweredState {
  tensionMeasurements: Measurement[];
  credibilityMeasurements: Measurement[];
  loadingMeasurements: boolean;
  loadingMeasurementsError?: string;
}

class MeasurementUnanswered extends Component<MeasurementUnansweredProps, MeasurementUnansweredState> {
  constructor(props: MeasurementUnansweredProps) {
    super(props);
    this.state = {
      tensionMeasurements: [],
      credibilityMeasurements: [],
      loadingMeasurements: true,
    };
  }

  componentDidMount(): void {
    this.getUnansweredMeasurements();
  }

  getUnansweredMeasurements(): void {
    const tensionMeasurements: Measurement[] = [];
    const credibilityMeasurements: Measurement[] = [];

    if (this.props.dossier) {
      this.setState({ loadingMeasurements: true });
      Api.measurementsUnanswered(this.props.dossier.id)
        .then(response => {
          const converted = response.map(measurement => new Measurement(measurement));
          converted.forEach((measurement) => {
            if (measurement.type === MeasurementTypeEnum.TENSION) {
              tensionMeasurements.push(measurement);
            } else if (measurement.type === MeasurementTypeEnum.CREDIBILITY) {
              credibilityMeasurements.push(measurement);
            }
          });
          this.setState({ tensionMeasurements: tensionMeasurements, credibilityMeasurements: credibilityMeasurements });
        })
        .catch(err => {
          this.setState({ loadingMeasurementsError: 'Laden van metingen mislukt, probeer het later opnieuw' });
          console.error('Failed to load measurements.', err);
        })
        .finally(() => this.setState({ loadingMeasurements: false }));
    } else {
      this.setState({
        loadingMeasurements: false,
        loadingMeasurementsError: 'Kan geen metingen laden doordat er geen dossier is geselecteerd'
      });
    }
  }

  handleClick = (measurement: Measurement): void => {
    this.props.history.push(`${ERouterPath.measurement}?id=${measurement.id}`);
  };

  render(): ReactNode {
    const {
      tensionMeasurements,
      credibilityMeasurements,
      loadingMeasurements,
      loadingMeasurementsError } = this.state;

    const isEmpty = tensionMeasurements.length === 0 && credibilityMeasurements.length === 0 && !loadingMeasurements;

    return (
      <MeasurementSplitLayout>
        {isEmpty && <Alert className="measurements-unanswered__info" variant="info">Er zijn geen openstaande metingen</Alert>}
        {loadingMeasurementsError && <Alert variant="danger">{loadingMeasurementsError}</Alert>}
        {loadingMeasurements && <Spinner animation="border" variant="primary" />}
        <div title="Openstaande metingen" className="measurements-unanswered">
          <p className="measurements-unanswered__credibility-title">{isEmpty ? '' : 'Geloofwaardigheid'}</p>
          <div title="Geloofwaardigheid" className="measurements-unanswered__credibility">
            {
              credibilityMeasurements.map((measurement) => (
                <NavigationBlock
                  key={measurement.id}
                  title={measurement.typeHuman || 'Meting'}
                  subTitle={`"${measurement.question}"`}
                  onClick={() => this.handleClick(measurement)}
                >
                </NavigationBlock>
              ))
            }
          </div>
          <p className="measurements-unanswered__tension-title">{isEmpty ? '' : 'Spanning'}</p>
          <div title="Spanning" className="measurements-unanswered__tension">
            {
              tensionMeasurements.map((measurement) => (
                <NavigationBlock
                  key={measurement.id}
                  title={measurement.typeHuman || 'Meting'}
                  subTitle={`"${measurement.question}"`}
                  onClick={() => this.handleClick(measurement)}
                >
                </NavigationBlock>
              ))
            }
          </div>
        </div>
      </MeasurementSplitLayout>
    );
  }
}

export default connect((state: ApplicationState) => ({
  dossier: state.session.dossier,
}))(MeasurementUnanswered);
